import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { CtaButton } from './CtaButton';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-lavender px-4 py-14" data-id="element-73" data-mp="1gd7iadgirj84">
      <div className="mx-auto max-w-2xl" data-id="element-74" data-mp="1geimufhsgv0a">
        <h2 className="text-center font-serif text-[28px] font-bold text-ink sm:text-4xl" data-id="element-75" data-mp="2e066s0x25kux">Frequently asked questions</h2>
        <ul className="mt-8 space-y-3" data-id="element-76" data-mp="29139j2nbkixi">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="rounded-2xl bg-white" data-id="element-77" data-mp="240fe84s25fxh" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-plum rounded-2xl" data-id="element-78" data-mp="1z25fxlb1dz7n">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-plum transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-79" data-mp="ufzlk89u476y" />
                </button>
                <AnimatePresence initial={false} data-id="element-80" data-mp="khtjnqo13123">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-81" data-mp="6qwru21xenw3">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-muted" data-id="element-82" data-mp="1q95vusk0x8q">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <CtaButton className="mt-10" label="I’m ready — give me access" data-id="element-83" data-mp="1uhcs9jl0a2b5" />
      </div>
    </section>;
}